import React, { useContext, useEffect, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  Button,
  RSelect
} from "../../../components/Component";
import { useNavigate, useParams } from "react-router-dom";
import { currentTime, findUpper, monthNames, todaysDate } from "../../../utils/Utils";
import {  DropdownItem, UncontrolledDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { Modal, ModalBody } from "reactstrap";
import UserProfileAside from "../../pre-built/user-manage/UserProfileAside";
import DatePicker from "react-datepicker";
import { countryOptions, userData } from "../../pre-built/user-manage/UserData";
import { getDateStructured } from "../../../utils/Utils";

import { Card } from "antd";
const HowToSell = () => {
  const [sm, updateSm] = useState(false);
  const [mobileView , setMobileView] = useState(false);
  
  const [modalTab, setModalTab] = useState("1");
  const [userInfo, setUserInfo] = useState(userData[0]);
  const [formData, setFormData] = useState({
    name: "Abu Bin Ishtiak",
    displayName: "Ishtiak",
    phone: "818474958",
    dob: "1980-08-10",
    address: "2337 Kildeer Drive",
    address2: "",
    state: "Kentucky",
    country: "Canada",
  });
  const [modal, setModal] = useState(false);

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitForm = () => {
    let submitData = {
      ...formData,
    };
    setUserInfo(submitData);
    setModal(false);
  };

  // function to change the design view under 990 px
  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  useEffect(() => {
    
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    document.getElementsByClassName("nk-header")[0].addEventListener("click", function () {
      updateSm(false);
    });
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);
  
  return (
    <React.Fragment>
      <Head title="How to sell SMS"></Head>
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                sm ? "content-active" : ""
              }`}
            >
              <UserProfileAside updateSm={updateSm} sm={sm} />
            </div>
            <div className="card-inner card-inner-lg">
              {sm && mobileView && <div className="toggle-overlay" onClick={() => updateSm(!sm)}></div>}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">Who are TextLink sellers</BlockTitle>
                    <BlockDes>
                      <p>This is an explanation of selling on TextLink.</p>
                    </BlockDes>
                  </BlockHeadContent>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""}`}
                      onClick={() => updateSm(!sm)}
                    >
                      <Icon name="menu-alt-r"></Icon>
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>

              <Block>
              <div className="bq-note">
                     
                          <div className="bq-note-item" >
                            <div className="bq-note-text">
                              <p>Selling is a simple way to earn passive income without doing much. You can get started in minutes with any android device and can earn 1000's of $ a month.</p>
                            </div>
                         
                          </div>
                          <div className="bq-note-item" >
                            <div className="bq-note-text">
                              <p>Requierments are to have at least one android with a SIM card.</p>
                            </div>
                         
                          </div>
                          <div className="bq-note-item" >
                            <div className="bq-note-text">
                              <p>After you set everything up, we will sometimes send text messages through your device (you won't notice it).<br/> You can either use your device, or set up a standalone android to always be on charger if you don't want to use your own.</p>
                            </div>
                         
                          </div>
                          <div className="bq-note-item" >
                            <div className="bq-note-text">
                            {mobileView? <p>Earn while you sleep, click the button below to set everything up, or contact us at info@textlinksms.com to find out more.</p>
                             : <p>Earn while you sleep, if you have any questions, contact us at info@textlinksms.com to find out more.</p>}

                            </div>
                         
                          </div>
                          {mobileView&&<Button color="primary" style={{marginTop:15}} onClick={()=>updateSm(true)}>
                        <Icon name="reports"></Icon>
                        <span>Get started</span>
                      </Button>     }                
                       </div>
              </Block>

            
            </div>
          </div>
        </Card>
      </Content>
    </React.Fragment>
  );
};

export default HowToSell;
